import { ReportTypes } from "../../../interfaces/Reports";
import { JobConfig } from "../interfaces/JobScheduler";

export const JobConfigs: Record<ReportTypes, JobConfig> = {
  [ReportTypes.SCHEME_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Scheme Report",
    category: "",
  },
  [ReportTypes.LIABILITY_SUMMARY_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Liability Summary Report",
    category: "",
  },
  [ReportTypes.TRANSACTION]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Transaction Report",
    category: "",
  },
  [ReportTypes.MEMBER_BILL_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Member Bill Report",
    category: "",
  },
  [ReportTypes.FRAUD_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Fraud Report",
    category: "",
  },
  [ReportTypes.OVERALL_LEAD_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Overall Lead Report",
    category: "",
  },
  [ReportTypes.LEAD_HISTORY_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Lead History Report",
    category: "",
  },
  [ReportTypes.STORE_CATEGORY_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Store Category Report",
    category: "",
  },
  [ReportTypes.SOURCE_EFFICIENCY_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Source Efficiency Report",
    category: "",
  },
  [ReportTypes.STORE_EFFICIENCY_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Store Efficiency Report",
    category: "",
  },
  [ReportTypes.STORE_PERSON_EFFICIENCY_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Store Person Efficiency Report",
    category: "",
  },
  [ReportTypes.PRODUCT_HIERARCHY_EFFICIENCY_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Product Hierarchy Efficiency Report",
    category: "",
  },
  [ReportTypes.LEAD_TELECALL_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Lead Telecall Report",
    category: "",
  },
  // Run on demand only (no automation) — it is for finding and fixing data.
  [ReportTypes.LEAD_DATA_QUALITY_REPORT]: {
    enabled: false,
    headers: [],
    fields: [],
    label: "Lead Data Quality Report",
    category: "",
  },
  [ReportTypes.OVERALL_CAMPAIGN_REPORT]: {
    enabled: true,
    headers: [],
    fields: [],
    label: "Overall Campaign",
    category: "Campaign Report",
  },
  [ReportTypes.INDIVIDUALIZED_CAMPAIGN_REPORT]: {
    enabled: true,
    headers: [],
    fields: [],
    label: "Customer",
    category: "Campaign Report",
  },
  [ReportTypes.CAMPAIGN_VARIANT_REPORT]: {
    enabled: true,
    headers: [],
    fields: [],
    label: "Variant",
    category: "Campaign Report",
  },
  [ReportTypes.RFM_SPLIT_VARIANT_REPORT]: {
    enabled: true,
    headers: [],
    fields: [],
    label: "Variant RFM",
    category: "Campaign Report",
  },
  [ReportTypes.TIER_SPLIT_VARIANT_REPORT]: {
    enabled: true,
    headers: [],
    fields: [],
    label: "Variant Tier",
    category: "Campaign Report",
  },
  [ReportTypes.RFM_SPLIT_CAMPAIGN_REPORT]: {
    enabled: true,
    headers: [],
    fields: [],
    label: "Customer RFM",
    category: "Campaign Report",
  },
  [ReportTypes.TIER_SPLIT_CAMPAIGN_REPORT]: {
    enabled: true,
    headers: [],
    fields: [],
    label: "Customer Tier",
    category: "Campaign Report",
  },
  [ReportTypes.CAMPAIGN_CHANNEL_SPLIT]: {
    enabled: true,
    headers: [],
    fields: [],
    label: "Channel",
    category: "Campaign Report",
  },
  [ReportTypes.CAMPAIGN_VARIANT_CHANNEL]: {
    enabled: true,
    headers: [],
    fields: [],
    label: "Variant Channel Level",
    category: "Campaign Report",
  },
  [ReportTypes.KPI_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "KPI Report",
    category: "",
  },
  [ReportTypes.OFFER_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Offer Report",
    category: "",
  },
  [ReportTypes.OFFER_REDEMPTION_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Offer Redemption Report",
    category: "",
  },
  [ReportTypes.OFFER_EARN_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Offer Earn Report",
    category: "",
  },
  [ReportTypes.VOUCHER_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Gift Voucher Report",
    category: "",
  },
  [ReportTypes.STORE_HEALTH_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Store Health Report",
    category: "",
  },
  [ReportTypes.STORE_KPI_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Store KPI Report",
    category: "",
  },
  [ReportTypes.STORE_STATUS_ACTIVITY]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Store Status Activity Report",
    category: "",
  },
  [ReportTypes.SURVEY_RESPONSE_REPORT]: {
    enabled: true,
    headers: ["Surveys"],
    fields: ["surveys"],
    label: "Survey Response Report",
    category: "Survey",
  },
  [ReportTypes.FRIEND_REFERRAL_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "Friend Referral Report",
    category: "",
  },
  [ReportTypes.PWA_ENROLMENT_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "PWA Enrolment Report",
    category: "",
  },
  [ReportTypes.ECOM_PRODUCT_VIEWS_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "ECOM Product Views",
    category: "ECOM",
  },
  [ReportTypes.ECOM_LANDING_EVENTS_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "ECOM Landing Events",
    category: "ECOM",
  },
  [ReportTypes.ECOM_CART_ITEMS_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "ECOM Cart Items",
    category: "ECOM",
  },
  [ReportTypes.ECOM_SUMMARY_REPORT]: {
    enabled: true,
    headers: ["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label: "ECOM Summary",
    category: "ECOM",
  },
  [ReportTypes.SOCIAL_MEDIA_CAMPAIGNS_REPORT]: {
        enabled:true,
        headers:["Selected Date"],
        fields: ["dateFilters.inLastDays"],
        label:"Social Media Campaign Report",
        category:""
      },
  [ReportTypes.TICKET_EXPORT]: {
    enabled:false,
    headers:["Selected Date"],
    fields: ["dateFilters.inLastDays"],
    label:"Ticket Export",
    category:""
  },
};
